import React, { Component } from 'react';
import classnames from 'classnames';
/** PERSONAL */
import Stem, { ItemList, Option } from './Stem';
import Footer from '../Footer';
import { reverseParseTextView } from './createRender';

const $ = require('$');
const MathQuill = require('MathQuill');
const MQ = MathQuill.getInterface(2);

class Question extends Component {
    constructor(props) {
        super(props);
        
        const visible = props.showAnswer ? true : false;

        this.state = {
            visible: visible,
            data: reverseParseTextView(props.obj)
        };
    }

    componentDidMount() {
        this.MQLoad();
    }

    componentDidUpdate(prevProps, prevState) {
        this.MQLoad();

        if (this.props.hasOwnProperty('showAllAnswer') && this.props.showAllAnswer !== prevProps.showAllAnswer) {
            this.setState({ visible: this.props.showAllAnswer });
        }
    }

    MQLoad = () => {
        $('.mathquill-embedded-latex', this.refs.viewer).removeAttr('style').each(function (index, item) {
            MQ.StaticMath(item);
        });
    };

    // 显示答案
    toggleAnswer = (val) => {
        this.setState({ visible: val });
    };

    // 导出题目
    handleExport = () => {
        const { handleExport } = this.props;
        handleExport && handleExport();
    };

    // 获取替换题目列表
    getReplaceQuestion = () => {
        const { getReplaceQuestion } = this.props;
        getReplaceQuestion && getReplaceQuestion();
    };

    // 更换题目
    handleReplace = () => {
        const { handleReplace } = this.props;
        handleReplace && handleReplace();
    };

    render() {
        const { visible, data } = this.state;
        const { stem, item_list, answerMap, stemMap, answer, itemMap } = data;
        const { num, canShowAnswer, canExport, canRelpace, handleReplace, exported } = this.props;
        const classname = classnames('question-wrapper', 'question-classify', {
            'exported': exported
        });

        return (
            <div className={classname} ref={(el) => this.viewer = el}>
                <div className="question-content">
                    <div className="question-order">
                        <p className="math_text"><span>{`${num + 1}.`}</span></p>
                    </div>
                    <div className="question-stem">
                        <Stem stem={stem} />
                        {
                            !!item_list.length &&
                            <div>
                                <p style={{ fontSize: 14, color: '#c3cad0', marginBottom: 10 }}>选项：</p>
                                <ItemList item_list={item_list} />
                            </div>
                        }
                    </div>
                </div>
                <div className="question-footer">
                    {
                        visible && <div className="footer-hide relative">
                            <div className='inline-block'>{this.props.errorAnswer?'错误答案：':'正确答案：'}</div>
                            <div className='inline-block'>
                                {
                                    answer.map((val, index) =>
                                        <div className="category-list" key={index}>
                                            <p>{stemMap[val.drop_id]}</p>
                                            {
                                                answerMap[val.drop_id].map((item, i) => (
                                                    <Option option={itemMap[item]} key={i} />
                                                ))
                                            }
                                        </div>
                                    )
                                }
                            </div>
                        </div>
                    }
                    <div className="footer-show">
                        <Footer {...this.props}>
                            {
                                canShowAnswer ?
                                    <button
                                        className="question-btn"
                                        onClick={() => this.toggleAnswer(!visible)}>
                                        {!visible ? '显示答案' : '隐藏答案'}
                                    </button> : null
                            }
                            {
                                canExport ?
                                    <button
                                        className="question-btn"
                                        style={{ right: 110 }}
                                        onClick={this.handleExport}>
                                        {!exported ? '选择' : '取消'}
                                    </button> : null
                            }
                            {
                                canRelpace ?
                                    <button
                                        className="question-btn"
                                        style={{ right: 110 }}
                                        onClick={this.getReplaceQuestion}>更换此题</button> : null
                            }
                            {
                                handleReplace ?
                                    <button
                                        className="question-btn"
                                        style={{ right: 110 }}
                                        onClick={this.handleReplace}>选择</button> : null
                            }
                        </Footer>
                    </div>
                </div>
            </div>
        )
    }
}

export default Question;


// WEBPACK FOOTER //
// ./src/entry_question_editor/question/exercise/classify/view.js